import { gql } from '@apollo/client'

const REMOVE_NONPROFIT_ORG_USER = gql`
  mutation removeNonprofitOrgUser(
    $removeNonprofitOrgUserInfo: RemoveNonprofitOrgUserInput!
    $nonprofitOrgId: Int!
  ) {
    removeNonprofitOrgUser(
      removeNonprofitOrgUserInfo: $removeNonprofitOrgUserInfo
      nonprofitOrgId: $nonprofitOrgId
    ) {
      nonprofitOrgId
    }
  }
`

export default REMOVE_NONPROFIT_ORG_USER
